var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFound"},[_vm._m(0),_c('h3',[_vm._v("糟糕，页面迷路了")]),_c('span',[_vm._v("你访问的页面可能已失效或被删除")]),_c('div',{staticClass:"back"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/404.png"),"alt":""}})])
}]

export { render, staticRenderFns }